import { Link } from 'components/common';
import useOrgProfileLink from 'hooks/useOrgProfileLink';
import { Owners, OwnersBar } from './styled';
import { getResearcherText } from 'utils/constants';

import { Label } from './styled';
import ActivityIcon from './ActivityIcon';
import { formatResearcherFullName } from 'utils/researcherName';

const OwnersDetails = ({ researchers, organisations }) => {
  const orgProfileLink = useOrgProfileLink();

  return (
    <OwnersBar>
      <Owners>
        {' '}
        <Label>
          <ActivityIcon icon='user' />
          {getResearcherText({ isPlural: true, capitalize: true })}:
        </Label>{' '}
        {researchers.map(researcher => (
          <Link
            size='sm'
            key={`researcher-activity-${researcher.id}`}
            to={`/researcher/${researcher.id}`}
            showIconHint
          >
            {formatResearcherFullName(researcher.name)}
          </Link>
        ))}
      </Owners>
      {organisations && !organisations.every(org => org.id === 0) && (
        <Owners>
          <Label>
            <ActivityIcon icon='company' />
            Organisations:
          </Label>
          {organisations.map(org => {
            if (org.id === 0) return null;
            return (
              <Link
                size='sm'
                key={`organisation-activity-${org.id}`}
                to={orgProfileLink(org.id)}
                showIconHint
              >
                {org.name}
              </Link>
            );
          })}
        </Owners>
      )}
    </OwnersBar>
  );
};

export default OwnersDetails;
